import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import * as moment from 'moment';

import {
  InfiniteScrollCustomEvent,
  ModalController,
  NavController,
  PopoverController,
} from '@ionic/angular';
import { Item } from 'firebase/analytics';
import { FormGroup } from '@angular/forms';
import { LhStorageService } from '@hssa-itasia/ngx-util-core';
import { AppConstants } from '../providers/constants/app-constants.service';
import { BaseInjectorService } from '../base/base-service.injector';
import { AddContractorComponent } from './bog_tour/add-contractor/add-contractor.component';
import { AppService } from '../app.service';
import { SearchService } from '../providers/search-service/search-service';
@Component({
  selector: 'bravo-good-practice',
  styles: [
    `
      .user_name {
        display: block;
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.51px;
        color: #000000;
        opacity: 1;
      }
      .user_email {
        display: block;
        word-break: break-all;
        text-align: left;
        font-size: 12px;
        letter-spacing: 0.38px;
        color: #000000;
        opacity: 1;
      }
      .textBox {
        max-width: 100%;
        width: 100%;
        margin-top: 10px;
      }
      .mandatory {
        color: red;
        font-size: 15px;
      }
      .UserRow {
        display: flex;
        margin-top: 5px;
      }
      .userNameCol {
        display: grid;
        position: relative;
      }

      .userphotoList_col {
        max-width: 45px;
      }
      .userInfoList_col {
        padding-top: 7px !important;
      }
      .userselecttion_col {
        max-width: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .emailCss {
        font-size: 12px;
        display: block;
        position: relative;
        margin-top: 2px;
        text-align: left;
        letter-spacing: 0.38px;
        color: #000000;
        opacity: 1;
      }
      .unselected_css {
        height: 20px;
        width: 20px;
        float: right;
        margin-top: 11px;
        border: 1px solid var(--ion-Teal-color);
        border-radius: 4px;
      }
      .selected_css {
        height: 21px;
        width: 21px;
        float: right;
        margin-top: 11px;
        border-radius: 4px;
        background-color: var(--ion-Teal-color);
        text-align: center;
        ion-icon {
          color: var(--ion-white-color);
          font-size: 19px;
          margin-bottom: 4px;
        }
      }
      .dummyUser_css {
        border-radius: 50%;
        overflow: hidden;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        width: 40px;
        margin-left: -4px;
      }
      .nameCss {
        font-size: 16px;
        display: block;
        position: relative;
        text-align: left;
        letter-spacing: 0.51px;
        color: #000000;
        opacity: 1;
      }
      .searchList_Div {
        height: 100px;
        color: #000;
      }
      .emp_type {
        border-radius: 4px;
        opacity: 1;
        padding: 5px;
        word-break: break-all;
        font-size: 12px;
      }
      .employee_css {
        background: #d6f4f1 0% 0% no-repeat padding-box;
        color: #007382;
      }
      .contractor_css {
        background: #c6f2ff 0% 0% no-repeat padding-box;
        color: #2674d1;
      }
      .not_found_css {
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.51px;
        color: #000000;
        font-weight: 100;
      }
      .searchUser_css {
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.51px;
        color: #000000;
        font-weight: bold;
        margin-left: 5px;
      }
      .addContractor_btn_css {
        border: 1px solid #027382;
        border-radius: 40px;
        opacity: 1;
        height: 40px;
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.51px;
        color: #017180;
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 5px;
      }
      .no_display_css {
        display: none;
      }
      .display_css {
        display: block;
        position: relative;
      }
      .email_col {
        display: flex;
        vertical-align: middle;
        position: relative;
        margin: 0 auto;
      }
      .email_col_div {
        display: block;
      }
      .search_icon {
        color: #007382;
        font-size: 25px;
        margin-right: 10px;
      }
      .notes_div {
        width: 27px;
        height: 27px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #027382;
        border-radius: 6px;
        opacity: 1;
      }
      .notes_col {
        width: 36px;
        max-width: 36px;
      }
      .notes_icon {
        font-size: 20px;
        color: var(--ion-color-secondary);
      }
      .user_type_span {
        padding: 1px 4px;
        font-size: 16px;
        border-radius: 2px;
      }

      .cancelBtn {
        height: 48px;
        border: 1px solid #027382;
        border-radius: 40px;
        opacity: 1;
        background: #fff;
        padding: 0 30px;
        color: #017180;
      }
      .saveBtn {
        height: 48px;
        background: #027382;
        border: 1px solid #027382;
        border-radius: 40px;
        opacity: 1;
        padding: 0 30px;
        color: #fff;
      }
      .add_action_btn_col {
        display: flex;
        justify-content: right;
      }
      .description_div {
        text-align: left;
        font-size: 16px;
        letter-spacing: 0.15px;
        color: #000000;
        opacity: 1;
      }
      .description_date_div {
        text-align: left;
        font-size: 12px;
        letter-spacing: 0.38px;
        color: #000000ab;
        opacity: 1;
      }
    `,
  ],
  template: `
    <div *ngIf="to.source == 'VPC_ADD' && to.type == 'search'">
      <ion-row>
        <ion-col class="i_discussed_label">
          {{ to.title | translate }} <span *ngIf="to.required" class="mandatory">*</span>
        </ion-col>
      </ion-row>
      <div *ngIf="isSelected">
        <ion-row class="UserRow">
          <ion-col class="userphotoList_col">
            <ion-icon
              *ngIf="!selected_user?.profile_image"
              class="dummyUser_css"
              name="person-circle-outline"
              style="color:#007382;"
            ></ion-icon>
            <img
              *ngIf="selected_user.profile_image"
              class="dummyUser_css"
              src="{{ selected_user?.profile_image }}"
            />
          </ion-col>
          <ion-col class="email_col">
            <div class="email_col_div">
              <div class="user_name">
                {{ selected_user?.Fname }} {{ selected_user?.Lname }}
                <span class="employee_css user_type_span">E</span>
              </div>
              <div class="user_email">{{ selected_user?.email }}</div>
            </div>
            <div></div>
          </ion-col>
          <ion-col class="notes_col" (click)="editSelectedUser()">
            <div class="notes_div">
              <ion-icon class="notes_icon" name="reader-outline"></ion-icon>
            </div>
          </ion-col>
        </ion-row>
        <div *ngIf="!isDescriptionSave">
          <ion-row>
            <ion-col>
              <form [formGroup]="i_discussed_descr_Form">
                <formly-form
                  [fields]="i_discussed_descr_fields"
                  [form]="i_discussed_descr_Form"
                ></formly-form>
              </form>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col class="add_action_btn_col">
              <ion-chip
                aria-label="cancel-test"
                role="cancel-test"
                Accessibility-ID="cancel-test"
                (click)="cacneBnt()"
                class="cancelBtn"
              >
                <ion-label> {{ 'ADD_QR.BTN_CANCEL' | translate }}</ion-label>
              </ion-chip>
              <ion-chip
                aria-label="cancel-test"
                role="cancel-test"
                Accessibility-ID="cancel-test"
                (click)="saveBtn()"
                class="saveBtn"
              >
                <ion-label> {{ 'ADD_QR.BTN_SAVE' | translate }}</ion-label>
              </ion-chip>
            </ion-col>
          </ion-row>
        </div>
        <div *ngIf="isDescriptionSave">
          <ion-row>
            <ion-col class="description_div">
              {{ selected_user?.bravo_good_practice_description }}
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col class="description_date_div">
              {{ selected_user?.bravo_good_practice_date | date: 'dd-MMM-yyyy' }}
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col class="add_action_btn_col">
              <ion-chip
                aria-label="cancel-test"
                role="cancel-test"
                Accessibility-ID="cancel-test"
                (click)="editBtn()"
                class="cancelBtn"
              >
                <ion-label> Edit</ion-label>
              </ion-chip>
            </ion-col>
          </ion-row>
        </div>
      </div>
      <ion-row *ngIf="!isSelected">
        <ion-col>
          <mat-form-field appearance="outline" class="textBox">
            <mat-label>{{ to.subtitle | translate }}</mat-label>
            <input
              matInput
              [placeholder]="placeHolder"
              [(ngModel)]="searchUser"
              (ngModelChange)="keyDownFunction($event)"
            />
            <ion-icon matSuffix class="search_icon" name="search-outline"></ion-icon>
          </mat-form-field>
        </ion-col>
      </ion-row>
      <div
        class="searchList_Div"
        [ngStyle]="{ height: searchListHeight }"
        *ngIf="searchTerm != '' && searchUsersList.length > 0"
      >
        <cdk-virtual-scroll-viewport class="ion-content-scroll-host" [itemSize]="10">
          <div *cdkVirtualFor="let user of searchUsersList">
            <ion-row class="UserRow" (click)="selectedUser(user)">
              <ion-col class="userphotoList_col">
                <ion-icon
                  *ngIf="!user.profile_image"
                  class="dummyUser_css"
                  name="person-circle-outline"
                  style="color:#007382;"
                ></ion-icon>
                <img
                  *ngIf="user.profile_image"
                  class="dummyUser_css"
                  src="{{ user.profile_image }}"
                />
              </ion-col>
              <ion-col class="email_col">
                <div class="email_col_div">
                  <div class="user_name">{{ user.Fname }} {{ user.Lname }}</div>
                  <div class="user_email">{{ user.email }}</div>
                </div>
              </ion-col>
              <ion-col class="userselecttion_col">
                <div class="emp_type employee_css">EMPLOYEE</div>
              </ion-col>
            </ion-row>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>

      <div *ngIf="searchTerm != '' && searchUsersList.length == 0">
        <ion-row>
          <ion-col>
            <div class="searchUser_css">
              {{ searchTerm }} <span class="not_found_css">,Not Found</span>
            </div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-buttons class="addContractor_btn_css" (click)="addContractor()">
              Add Contractor
            </ion-buttons>
          </ion-col>
          <ion-col> </ion-col>
        </ion-row>
      </div>
    </div>
  `,
  standalone: false,
})
export class BravoGoodPracticesFormlyType extends FieldType {
  i_discussed_descr_Form: any = new FormGroup({});
  i_discussed_descr_fields: FormlyFieldConfig[] = [
    {
      key: 'description',
      type: 'textarea',
      className: 'treasure-hunt-custom-add-action-description',
      props: {
        label: 'VPC.FORM_DESC',
        required: true,
        maxLength: 2000,
        rows: 3,
        appearance: 'outline',
      },
    },
  ];
  searchControl: Subject<string> = new Subject();
  searchUser: any;
  searchUsersList: any;
  searchTerm: any = '';
  searchListHeight: string = '100px';
  selected_user: any = {};
  isSelected: boolean = false;
  isDescriptionSave: boolean = false;
  placeHolder: any;
  level: string = 'immediate_risk';
  constructor(
    private changeDetection: ChangeDetectorRef,
    private modal: ModalController,
    private searchService: SearchService,
    private appService: AppService,
    private lhStorage: LhStorageService
  ) {
    super();
    let usersList = this.appService.appData.usersByCountry.filter((element: any) => {
      if (element.person_id) {
        return true;
      } else {
        return false;
      }
    });

    this.searchUsersList = [];
    this.searchService.item = usersList.sort((a, b) => a.email.localeCompare(b.email));
  }
  keyDownFunction(event: any) {
    this.searchControl.next(event);
  }
  setSearchedPolicy(searchText) {
    this.searchUsersList = [];
    this.searchTerm = '';
    if (searchText != '') {
      this.searchTerm = searchText;
      this.searchUsersList = this.searchService.filterSearch(searchText, 'id');
      if (this.searchUsersList.length == 1) this.searchListHeight = '100px';
      else if (this.searchUsersList.length == 2) this.searchListHeight = '130px';
      else if (this.searchUsersList.length > 2) this.searchListHeight = '190px';
    }
    this.changeDetection.detectChanges();
  }

  async ngOnInit() {
    this.isSelected = false;
    this.isDescriptionSave = false;
    this.setSearchedPolicy('');
    this.searchControl.pipe(debounceTime(700), distinctUntilChanged()).subscribe((searchText) => {
      this.setSearchedPolicy(searchText);
    });
    let subscribtion = this.appService.riskLevelSubject.subscribe((res: any) => {
      this.level = res;
    });
    let editObservation = await this.lhStorage.get('editObservation');
    if (editObservation != null || editObservation != undefined) {
      let data: any = editObservation.currentObservationInfo;
      if (data?.bravo_good_practice) {
        this.isSelected = true;
        this.selected_user = data.bravo_good_practice;
        this.selected_user.bravo_good_practice_date =
          data.bravo_good_practice.bravo_good_practice_date;
        this.i_discussed_descr_fields[0].defaultValue =
          data.bravo_good_practice.bravo_good_practice_description;
        this.changeDetection.detectChanges();
      }
    }
  }
  async addContractor() {
    const modal = await this.modal.create({
      component: AddContractorComponent,
      cssClass: 'add_contractor_popup_css',
      backdropDismiss: true,
      componentProps: {},
    });
    await modal.present();
    let response = await modal.onDidDismiss();
    if (response?.data?.data) {
      let res = response?.data?.data;
      this.selectedUser(res);
    }
  }
  selectedUser(item) {
    this.isSelected = true;
    this.selected_user = item;
    this.searchTerm = '';
    this.searchUsersList = [];
    this.selected_user['bravo_good_practice_description'] = '';
    this.selected_user['bravo_good_practice_date'] = '';
    this.formControl.patchValue(this.selected_user);
    this.formControl.markAsTouched();
  }
  saveBtn() {
    if (this.i_discussed_descr_Form.valid) {
      this.isDescriptionSave = true;
      this.selected_user.bravo_good_practice_description =
        this.i_discussed_descr_Form.value.description;
      this.selected_user.bravo_good_practice_date = (moment as any).default().toISOString();
      this.formControl.patchValue(this.selected_user);
      this.formControl.markAsTouched();
    } else this.appService.showDiscussedDescriptionErrorToast();
  }
  editBtn() {
    this.i_discussed_descr_fields[0].defaultValue =
      this.selected_user.bravo_good_practice_description;
    this.i_discussed_descr_fields[0].formControl.setValue(
      this.selected_user.bravo_good_practice_description
    );
    this.isDescriptionSave = false;
  }
  editSelectedUser() {
    this.isSelected = !this.isSelected;
  }
  cacneBnt() {
    this.isDescriptionSave = !this.isDescriptionSave;
  }
}
